// G-65: pick one of 12 icons and one of 8 colours, with a live preview.
import {
  ALLIANCE_EMBLEM_COLORS,
  ALLIANCE_EMBLEM_ICONS,
  type AllianceEmblem,
} from '@stars-and-ships/api-types';
import { EMBLEM_ICONS, Emblem } from './Emblem';

export function EmblemPicker({
  value,
  tag,
  onChange,
}: {
  value: AllianceEmblem;
  tag: string;
  onChange: (emblem: AllianceEmblem) => void;
}) {
  return (
    <div className="space-y-3">
      <Emblem emblem={value} tag={tag} size="lg" />
      <div role="radiogroup" aria-label="Icon" className="grid grid-cols-6 gap-2 sm:grid-cols-12">
        {ALLIANCE_EMBLEM_ICONS.map((icon) => {
          const Icon = EMBLEM_ICONS[icon];
          const chosen = value.icon === icon;
          return (
            // biome-ignore lint/a11y/useSemanticElements: a styled radio group of icon buttons
            <button
              key={icon}
              type="button"
              role="radio"
              aria-checked={chosen}
              aria-label={icon}
              onClick={() => onChange({ ...value, icon })}
              className={`flex size-11 items-center justify-center hud-cut-sm border ${chosen ? 'border-info text-info' : 'border-line text-muted'}`}
            >
              <Icon className="size-5" aria-hidden />
            </button>
          );
        })}
      </div>
      <div role="radiogroup" aria-label="Colour" className="flex flex-wrap gap-2">
        {ALLIANCE_EMBLEM_COLORS.map((color) => (
          // biome-ignore lint/a11y/useSemanticElements: a styled radio group of colour swatches
          <button
            key={color}
            type="button"
            role="radio"
            aria-checked={value.color === color}
            aria-label={color}
            onClick={() => onChange({ ...value, color })}
            style={{ backgroundColor: color }}
            className={`size-11 hud-cut-sm border-2 ${value.color === color ? 'border-text' : 'border-transparent'}`}
          />
        ))}
      </div>
    </div>
  );
}
